import { render, staticRenderFns } from "./TotalStockValue.vue?vue&type=template&id=b4978cf2&scoped=true&"
import script from "./TotalStockValue.vue?vue&type=script&lang=js&"
export * from "./TotalStockValue.vue?vue&type=script&lang=js&"
import style0 from "./TotalStockValue.vue?vue&type=style&index=0&id=b4978cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4978cf2",
  null
  
)

export default component.exports